export enum DashboardWidgetType {
  LANDLORD_ADD_PROPERTIES = '1',
  HAS_DEAL = '2',
  HAS_LEAD = '3', // (missing in dashboard selector) no widget yet
  HAS_ACTIVE_CASE = '4',
  MORTGAGE_EXPIRATION = '5',
  HAS_SMART_SEARCH_DEALS = '6', // (missing in dashboard selector) no widget yet
  MORTGAGE_WITH_NO_CASE_AND_MINIMAL_DATA = '7',
  MORTGAGE_WITH_NO_CASE_AND_DATA_FILLED = '8',
  ADD_MORTGAGE = '9', // (missing in dashboard selector) no widget yet
  ADD_PROPERTY = '10',
  ADD_SMART_SEARCH = '11',
  EPC_IMPROVEMENTS = '12',
}
